import {
    BOOLEAN_AS_STRING,
    PLBillDLSProperties,
    PLBillTextAnimation,
    PLBillTextPrimitive,
    RenderingDetails,
} from "@swiggy-private/cart-types";

import {
    FREE_TEXT_BANNER_BG,
    FREE_TEXT_SEPARATOR_GRADIENT,
    FREE_TEXT_VARIANT,
} from "./constants";

export const getFreeTextPrimitive = (itemData: RenderingDetails): PLBillTextPrimitive => {
    const { meta } = itemData;
    const bannerBg = meta?.bannerBgColor || FREE_TEXT_BANNER_BG;
    const separatorGradient = meta?.separatorGradient || FREE_TEXT_SEPARATOR_GRADIENT;

    return {
        type: "text",
        text: itemData.value || itemData.display_text,
        ...(String(meta?.showShimmer) === BOOLEAN_AS_STRING.TRUE && {
            animation: PLBillTextAnimation.SHIMMER_LEFT_TO_RIGHT,
        }),
        properties: {
            dls: {
                textVariant: FREE_TEXT_VARIANT,
                textColor: meta?.titleColor as PLBillDLSProperties["textColor"],
            },
            style: {
                background: `${bannerBg} 0 0 / 100% 100% no-repeat, ${separatorGradient} 0 100% / 100% 1px no-repeat`,
            },
        },
    };
};
